import request from "../request"
import qs from "qs";


export function getAuthCodeByPhone(params) {
  return request.get({
    url: "/security-auth/send-register-sms",
    params: params
  })
}
export function getRoleDataById(params) {
  return request.get({
    url: "/security/api/role/one",
    params: params
  })
}
export function getRoleTableData(params) {
  return request.get({
    url: "/security/api/role/listall",
    params: params
  })
}
export function getUserTableData(params) {
  return request.get({
    url: "/security/api/user/listall",
    params: params
  })
}
export function getPilotTableData(params) {
  return request.get({
    url: "/fly_auth/page",
    params: params
  })
}
export function getEnterpriseTableData(params) {
  return request.get({
    url: "/auth/page",
    params: params
  })
}
export function getRoleOptions() {
  return request.get({
    url: "/security/api/role/opt"
  })
}
export function getPermissionsList() {
  return request.get({
    url: "/security/api/permission/list"
  })
}


export function editRoleData(data) {
  return request.post({
    url: "/security/api/role/saveorupdate",
    data: qs.stringify(data),
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    }
  })
}

export function addUserData(data) {
  return request.post({
    url: "/security/api/user/addone",
    data: qs.stringify(data),
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    }
  })
}
export function editUserData(data) {
  return request.post({
    url: "/security/api/user/modpas",
    data: qs.stringify(data),
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    }
  })
}
export function auditEnterprise(data) {
  return request.post({
    url: "/auth/mod",
    data: qs.stringify(data),
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    }
  })
}
export function auditPilot(data) {
  return request.post({
    url: "/fly_auth/mod",
    data: qs.stringify(data),
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    }
  })
}


export function deleteRoleData(params) {
    return request.delete({
      url: "/security/api/role/del",
      params: params
    })
}
export function deleteUserData(params) {
    return request.delete({
      url: "/security/api/user/del",
      params: params
    })
}


